import {Mapper} from '@s-ui/domain'

export class FromDealersListRawDataToDealersListValueObjectMapper extends Mapper {
  constructor({config, dealersListValueObjectFactory, fromDealerRawDataToDealerEntityMapper}) {
    super()
    this._dealersListValueObjectFactory = dealersListValueObjectFactory
    this._fromDealerRawDataToDealerEntityMapper = fromDealerRawDataToDealerEntityMapper
  }

  map = async dealersListRaw => {
    const {results: dealersList, meta: {totalPages, totalResults} = {}} = dealersListRaw

    const items = await Promise.all(dealersList.map(dealer => this._fromDealerRawDataToDealerEntityMapper.map(dealer)))

    return this._dealersListValueObjectFactory({
      items,
      totalPages,
      totalResults
    })
  }
}
